import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ADD_TO_CART_QUANTITY } from "../../../../../Constants/CartConstants";
import "./ProductQuantity.scss";

interface PropsType {
  minimumQuantity: number;
  maximumQuantity: number;
}

const ProductQuantity: FC<PropsType> = ({
  minimumQuantity,
  maximumQuantity,
}) => {
  const dispatch = useDispatch();

  // existing redux value
  const reduxQty = useSelector((state: any) => state.cart);

  const [units, setUnits] = useState<number>(
    reduxQty
      ? Math.max(minimumQuantity, Math.min(reduxQty, maximumQuantity))
      : minimumQuantity
  );

  const [inputValue, setInputValue] = useState<string>(units.toString());

  useEffect(() => {
    dispatch({ type: ADD_TO_CART_QUANTITY, payload: units });
    setInputValue(units.toString());
  }, [units, dispatch]);

  const increase = () => {
    setUnits((prev) => Math.min(prev + 1, maximumQuantity));
  };

  const decrease = () => {
    setUnits((prev) => Math.max(prev - 1, minimumQuantity));
  };

  // manual input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val === "") {
      setInputValue("");
      return;
    }
    const num = parseInt(val, 10);
    if (!isNaN(num)) setInputValue(val);
  };

  const handleBlur = () => {
    let num = parseInt(inputValue, 10);
    if (isNaN(num)) num = minimumQuantity;
    num = Math.max(minimumQuantity, Math.min(num, maximumQuantity));
    setUnits(num);
  };

  return (
    <div className="unitCounter pb-3">
      <button
        type="button"
        onClick={decrease}
        disabled={units <= minimumQuantity}
      >
        -
      </button>

      <div className="countsLabel">
        <input
          type="number"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleBlur}
        />
        <span className="label">units</span>
      </div>

      <button
        type="button"
        onClick={increase}
        disabled={units >= maximumQuantity}
      >
        +
      </button>
    </div>
  );
};

export default ProductQuantity;

// import React, { FC, useEffect } from "react";
// import { ADD_TO_CART_QUANTITY } from "../../../../../Constants/CartConstants";
// import "./ProductQuantity.scss";
// import { useDispatch } from "react-redux";

// interface propsType {
//   maximumQuantity: number;
//   minimumQuantity: number;
// }

// const ProductQuantity: FC<propsType> = ({
//   minimumQuantity,
//   maximumQuantity,
// }) => {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch({ type: ADD_TO_CART_QUANTITY, payload: minimumQuantity });
//   }, []);

//   return (
//     <div className="productQuantity pb-3">
//       <label htmlFor="Qty">Quantity:</label>
//       <input
//         type="number"
//         id="Qty"
//         defaultValue={minimumQuantity}
//         max={maximumQuantity}
//         min={minimumQuantity}
//         className="form-control"
//         placeholder="Enter quantity"
//         onChange={(e: { target: { value: string } }) =>
//           dispatch({ type: ADD_TO_CART_QUANTITY, payload: e.target.value })
//         }
//         required
//       />
//     </div>
//   );
// };

// export default ProductQuantity;
